import React, { useState } from "react";

// reactstrap
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Col,
  Progress,
} from "reactstrap";

// navlink classnames
import classnames from "classnames";

function SkillSet({ skillTypes, skills }) {
  const [activeTab, setActiveTab] = useState(skillTypes[0]);

  function toggle(tab) {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  }

  const SkillNavLink = () => {
    return (
      <Nav tabs className="skills-nav">
        {skillTypes.map((skilltype, idx) => {
          // navlink class
          const navLinkClass =
            "rounded-0 font-weight-bold text-uppercase " +
            classnames({
              active: activeTab === skilltype,
            });

          return (
            <NavItem className="skills-tab" key={idx}>
              <NavLink
                className={navLinkClass}
                onClick={() => toggle(skilltype)}
              >
                {skilltype}
              </NavLink>
            </NavItem>
          );
        })}
      </Nav>
    );
  };

  const SkillBar = () => {
    return skillTypes.map((skillType, idx) => {
      const isNotEmpty = Array.isArray(skills) && skills.length !== 0;
      return (
        <TabPane tabId={skillType} key={idx}>
          <Row className="justify-content-center">
            <Col>
              {isNotEmpty
                ? skills.map((skill, idx) => {
                    const isSameSkillType = skill.skillType === skillType;
                    if (isSameSkillType) {
                      return (
                        <Progress multi className="rounded-0" key={idx}>
                          <Progress
                            bar
                            value={25}
                            className="progress-bar-title"
                          >
                            {skill.name}
                          </Progress>
                          <Progress
                            bar
                            value={skill.nameValue}
                            className="progress-bar-value"
                          />
                          <Progress
                            bar
                            value={skill.gradeValue}
                            className="skill-progress-bar-label"
                          >
                            {skill.grade}
                          </Progress>
                        </Progress>
                      );
                    } else {
                      return null;
                    }
                  })
                : ""}
            </Col>
          </Row>
        </TabPane>
      );
    });
  };

  const SkillTabContent = () => {
    return (
      <TabContent activeTab={activeTab} className="mt-3">
        <SkillBar />
      </TabContent>
    );
  };

  return (
    <Col
      lg={{ size: 7, order: 2 }}
      md={{ order: 1 }}
      className="align-self-top mb-5 mb-lg-0"
    >
      <div>
        <SkillNavLink />
        <SkillTabContent />
      </div>
    </Col>
  );
}

export default SkillSet;
